import { RouteConfig } from "vue-router";
import { App } from "@/shared/app";
import { searchResultRouteConfig } from "./searchResult/module";

export const searchApp: App = {
  route: "wyszukiwarka",
  title: "Wyszukiwarka",
};
